import { ref } from '@vue/composition-api';
import { nanoid } from 'nanoid';
import uniqby from 'lodash.uniqby';
import useEntity from '../_basic';
import useNotifications from './index';
import deviceContextMenu from '@/router/routes/notifications/item/entityActions';
import convertDate from '@/utils/convertDate';
import checkNull from '@/utils/checkNull';

export default (props, context) => {
  const entityComposition = useEntity(props, context);
  const entity = ref(null);
  const { notification } = useNotifications();

  const loadData = async (id, entityParam = entity) => {
    const entityLocal = entityParam;
    const objectNoty = await notification.load(id);
    const objectDeliveries = await notification.getNotificationDeliveries({
      filter: {
        notification: {
          id: {
            equalTo: id
          }
        }
      }
    });
    const createTabs = () => {
      const list = [
        {
          id: 'general',
          title: 'general',
          type: 'properties'
        },
        {
          id: 'deliveries',
          title: 'deliveries',
          type: 'list'
        }
      ];
      return list;
    };

    const createDeliveries = deliveries => {
      const uniqDeliveries = uniqby(deliveries, 'user');
      const list = [];

      uniqDeliveries.forEach(item => {
        const preFilled = {
          raw: {
            ...item,
            types: deliveries.filter(
              itemInner =>
                itemInner.notificationId === item.notificationId &&
                item.user === itemInner.user
            )
          },
          id: item.id,
          title: item.userLogin,
          subtitles: [`${convertDate(item.createdAt)}`],
          isHoverAction: true,
          contextMenu: [],
          actionClickElement: () => ({}),
          icon: 'none',
          action: 'info'
        };

        list.push(preFilled);
      });

      return list;
    };

    const createTags = tags => {
      let tagsInner = [];
      if (tags && Array.isArray(tags)) {
        tags.forEach(item => {
          tagsInner.push({
            id: nanoid(),
            title: item
          });
        });
      }
      if (tagsInner.length) {
        return {
          id: nanoid(),
          subheader: 'Tags',
          contextMenu: [
            {
              id: 'sendProperty',
              text: 'Send property',
              icon: 'mdi-format-vertical-align-bottom'
            },
            {
              text: 'Copy',
              icon: 'mdi-image-filter-none'
            },
            {
              id: 'show-history',
              text: 'Show history',
              icon: 'mdi-history'
            }
          ],
          properties: {
            chips: tagsInner
          }
        };
      }
      return null;
    };

    entityLocal.value = {
      image: '/img/notification.jpg',
      id: `${objectNoty.data.notification.id}`,
      title: checkNull(objectNoty.data.notification.objectName),
      contextMenu: deviceContextMenu,
      tabsMeta: createTabs(),
      tabs: [
        {
          items: [
            {
              id: nanoid(),
              subheader: 'General',
              contextMenu: [
                {
                  id: 'copy',
                  text: 'Copy',
                  icon: '',
                  _enabled: true
                }
              ],
              properties: [
                {
                  id: nanoid(),
                  title: checkNull(objectNoty.data.notification.objectName),
                  subtitle: 'Object name',
                  icon: '',
                  isHoverAction: true,
                  contextMenu: []
                },
                {
                  id: nanoid(),
                  title: `${convertDate(
                    objectNoty.data.notification.createdAt
                  )}`,
                  subtitle: 'Date & time',
                  icon: '',
                  isHoverAction: true
                }
              ]
            },
            createTags(objectNoty.data.notification.tags),
            {
              id: nanoid(),
              subheader: 'Message',
              contextMenu: [],
              properties: [
                {
                  id: nanoid(),
                  title: `${objectNoty.data.notification.message}`,
                  icon: 'none',
                  isHoverAction: false
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'Spec',
              contextMenu: [],
              properties: [
                {
                  id: nanoid(),
                  title: checkNull(objectNoty.data.notification.spec),
                  icon: 'none',
                  isHoverAction: false
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'UUID',
              contextMenu: [],
              properties: [
                {
                  id: nanoid(),
                  title: objectNoty.data.notification.id,
                  icon: 'none',
                  isHoverAction: false
                }
              ]
            }
          ],
          additionalItems: []
        },
        {
          items: [
            ...createDeliveries(objectDeliveries.data.notificationDeliveries)
          ],
          additionalItems: []
        }
      ]
    };

    notification.loading.value = false;
  };

  return {
    ...entityComposition,
    entity,
    loadData,
    loading: notification.loading
  };
};
